import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
  PDFPreview
} from '../../../FilePreview';
import {
  InteractionsMenuItem,
} from '../../InteractionsMenuItems';
import AbstractModalView
  from '../../../AbstractModalView';
import AnimatedUploadingFilePopUp from '../../../AnimatedUploadingFilePopUp';
import edit from '../../../../assets/brush-4A4A4A.svg';
import styles from './styles.module.scss';

const EditPDF = ({
                   fileID,
                   content,
                   setClickOutsideAllowed,
                   itemProps,
                   shumaId,
                   orderID,
                   editPDFPages,
                   editOrderPDFPages,
                   getFileList,
                   updateFile,
                   closeDropdown,
                   isFileFromOrder
                 }) => {
  const [loading, setLoading] = useState(false);

  const handleOpen = openModal => async () => {
    if (!Boolean(content)) {
      setLoading(true);
      await updateFile();
    }
    openModal();
    setClickOutsideAllowed(false);
    setLoading(false);
  };

  const mapPages = () => {
    /* Direct reading of the DOM tree is used to avoid re-rendering
       the PDF document after toggling a checkbox */
    let result = [];
    const checkboxes = document.getElementsByName('pdf-page-checkbox');
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        result = [...result, checkbox.getAttribute('data-page-number')];
      }
    });

    return result;
  };

  const handleConfirm = closeModal => () => {
    if (isFileFromOrder) {
      editOrderPDFPages({
        orderID,
        fileID,
        pages: mapPages(),
      })
        .then(() => getFileList({shumaId}))
        .then(() => updateFile())
        .then(() => setClickOutsideAllowed(true))
        .then(() => closeModal())
        .then(() => closeDropdown());
    } else {
      editPDFPages({
        shumaId,
        fileID,
        pages: mapPages()
      })
        .then(() => getFileList({shumaId}))
        .then(() => updateFile())
        .then(() => setClickOutsideAllowed(true))
        .then(() => closeModal())
        .then(() => closeDropdown());
    }
  };

  const handleReject = () => {
    setClickOutsideAllowed(true);
    closeDropdown();
  };

  return (
    <>
      <AnimatedUploadingFilePopUp show={loading}/>
      <AbstractModalView
        subPath={`edit-file-pdf-${fileID}`}
        triggerContent={({openModal}) => (
          <InteractionsMenuItem
            label={'עריכה'}
            icon={edit}
            onClick={handleOpen(openModal)}
            customClassnames={styles.interactionsMenuItemTop}
            {...itemProps[0]}
          />
        )}
        modalContent={({closeModal}) => (
          <div className={styles.editPDFcontainer}>
            <PDFPreview
              url={content}
              editMode={true}
            />
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={closeModal}
              >
                <span>ביטול</span>
              </button>
              <button
                type="button"
                className={styles.buttonSubmit}
                onClick={handleConfirm(closeModal)}
              >
                <span>עריכה</span>
              </button>
            </div>
          </div>
        )}
        onCloseModal={handleReject}
        modalContainerClassName={styles.modal}
      />
    </>
  );
};

EditPDF.propTypes = {
  fileID: PropTypes.number,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  setClickOutsideAllowed: PropTypes.func,
  itemProps: PropTypes.array,
  shumaId: PropTypes.string,
  editPDFPages: PropTypes.func,
  getFileList: PropTypes.func,
  updateFile: PropTypes.func,
  closeDropdown: PropTypes.func,
  isFileFromOrder: PropTypes.bool,
};

export default EditPDF;
